import React, { useState } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import url from './url';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isComplete, setIsComplete] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (password.length < 8) {
            setError('Your new password must be at least 8 characters.');
            return;
        }
        if (password !== confirmPassword) {
            setError('The passwords do not match.');
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await fetch(`${url}/api/password-reset/reset`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword: password }),
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(data.message || 'Unable to reset your password.');
            setIsComplete(true);
        } catch (submitError) {
            setError(submitError.message || 'Unable to reset your password.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main className="auth-page">
            <section className="auth-card">
                <span className="section-kicker">SECURE RESET</span>
                <h1>Choose a new<br /><em>password.</em></h1>
                {isComplete ? (
                    <div className="auth-success" role="status">
                        <strong>Password updated.</strong>
                        <p>You can now sign in using your new password.</p>
                        <NavLink to="/Login" className="btn btn-smth">Sign in</NavLink>
                    </div>
                ) : token ? (
                    <form onSubmit={handleSubmit} className="auth-form">
                        <label>
                            New password
                            <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="At least 8 characters" minLength="8" autoComplete="new-password" autoFocus />
                        </label>
                        <label>
                            Confirm new password
                            <input type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} placeholder="Enter it again" minLength="8" autoComplete="new-password" />
                        </label>
                        {error && <p className="account-error" role="alert">{error}</p>}
                        <button type="submit" className="btn btn-smth" disabled={isSubmitting}>
                            {isSubmitting ? 'Updating…' : 'Update password'} <span aria-hidden="true">↗</span>
                        </button>
                    </form>
                ) : (
                    <div className="auth-error-state">
                        <p>This password reset link is incomplete or invalid.</p>
                        <NavLink to="/ForgotPassword" className="btn btn-smth">Request a new link</NavLink>
                    </div>
                )}
            </section>
        </main>
    );
}

export default ResetPassword;